import {
  getCurrencyFromSetup,
  getEventTotalValue,
} from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import {
  getExpectedSolutionDate,
  getValueInCurrency,
} from "../../../common/utils";
import FieldValueItem from "../../../components/common/FieldValueItem";

export default function EventSummary({ eventInfo }) {
  const getAdditionalInfo = (data) => {
    if (data && data.length > 0) {
      const parsed = JSON.parse(data);

      return parsed;
    }

    return [];
  };

  return (
    <div>
      <p>
        <FieldValueItem fieldName={`* ${localize.general_information}`} />
        <FieldValueItem
          fieldName={`- ${localize.id}`}
          fieldValue={eventInfo?.Id}
        />
        <FieldValueItem
          fieldName={`- ${localize.code}`}
          fieldValue={eventInfo?.Code}
        />
        <FieldValueItem
          fieldName={`- ${localize.expected_attention_date}`}
          fieldValue={getExpectedSolutionDate(eventInfo)}
        />
        <FieldValueItem
          fieldName={`- ${localize.type}`}
          fieldValue={`${eventInfo?.EventType?.Name ?? localize.no_data}`}
        />
        <FieldValueItem
          fieldName={`- ${localize.proceeding}`}
          fieldValue={`${eventInfo?.ProceedingInfo?.Name ?? localize.no_data}`}
        />
        <FieldValueItem
          fieldName={`- ${localize.address}`}
          fieldValue={`${
            eventInfo?.Address
              ? `${eventInfo?.Address} ${eventInfo?.AddressComplement ?? ""}`
              : eventInfo?.AddressComplement ?? localize.no_data
          }`}
        />
        <FieldValueItem
          fieldName={`- ${localize.city}`}
          fieldValue={`${eventInfo?.City?.Name ?? localize.no_data}`}
        />
        <FieldValueItem
          fieldName={`- ${localize.department}`}
          fieldValue={`${eventInfo?.State?.Name ?? localize.no_data}`}
        />
        <FieldValueItem
          fieldName={`- ${localize.phone_number}`}
          fieldValue={`${eventInfo?.ReporterPhoneNumber ?? localize.no_data}`}
        />
        {eventInfo.Client && (
          <FieldValueItem
            fieldName={`- ${localize.client_name}`}
            fieldValue={eventInfo?.Client?.Name}
          />
        )}
        {eventInfo?.Client?.Name !== eventInfo?.ReporterName && (
          <FieldValueItem
            fieldName={`- ${localize.contact_name}`}
            fieldValue={eventInfo?.ReporterName}
          />
        )}
        <FieldValueItem
          fieldName={`- ${localize.service_value}`}
          fieldValue={`${
            getValueInCurrency(
              getCurrencyFromSetup(),
              eventInfo?.executionFinalValue
            ) ?? localize.no_data
          }`}
        />
        <FieldValueItem
          fieldName={`- ${localize.spare_parts_value}`}
          fieldValue={`${
            getValueInCurrency(
              getCurrencyFromSetup(),
              eventInfo?.sparePartsFinalValue
            ) ?? localize.no_data
          }`}
        />
        <FieldValueItem
          fieldName={`- ${localize.total_value}`}
          fieldValue={`${
            getValueInCurrency(
              getCurrencyFromSetup(),
              getEventTotalValue(eventInfo, true)
            ) ?? localize.no_data
          }`}
        />
        <FieldValueItem
          fieldName={`- ${localize.assigned_to}`}
          fieldValue={`${
            eventInfo?.PersonalAssigned
              ? `${eventInfo?.PersonalAssigned?.SurName} ${eventInfo?.PersonalAssigned?.LastName}`
              : localize.no_data
          }`}
        />
        <FieldValueItem
          fieldName={`- ${localize.observations}`}
          fieldValue={`${
            eventInfo?.Observation && eventInfo?.Observation?.length > 0
              ? eventInfo.Observation
              : localize.no_data
          }`}
        />
      </p>
      {eventInfo?.AdditionalFields?.length > 2 && (
        <p>
          <FieldValueItem fieldName={`* ${localize.additional_data}`} />

          {getAdditionalInfo(eventInfo?.AdditionalFields)?.map(
            (x) =>
              x.value &&
              x.value?.replaceAll(" ", "").length > 0 && (
                <FieldValueItem
                  fieldName={`- ${x.name}`}
                  fieldValue={x.value}
                />
              )
          )}
        </p>
      )}
    </div>
  );
}
